import { Pipe, PipeTransform, inject } from '@angular/core';
import {PersonOrganizationAffiliationData} from '../interfaces/person-organization-affiliation-data.model';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'researcherTitle', pure: false,
    standalone: true
})
export class ResearcherTitlePipe implements PipeTransform {
    private translate = inject(TranslateService);


    transform(affiliation: PersonOrganizationAffiliationData, args: any): string {
        if (!affiliation){
            return '';
        }

        let title = this.getResearcherTitle(affiliation, args);
        if (title && args?.suffix){
            title += args.suffix;
        }
        return title;
    }

    getResearcherTitle(affiliation: PersonOrganizationAffiliationData, args: any){
        let title = '';
        if (affiliation.title){
            title = affiliation.title;
        } else if (affiliation.position){
            title = this.translate.instant(affiliation.position);
        } else if (args?.generalPosition){
            title = this.translate.instant(args.generalPosition);
        }
        return title;
    }

}
